module.exports = __webpack_public_path__ + "static/year2016-b71daf17126479a4e490bda26459eef3.jpg";